<template>
  <section class="product-name card">
    <div class="flex flex-col gap-2">
      <locale-link :to="`/regions/${regionId}/branches/${props.product?.bid}`">
        <span class="text-yellow-50">{{ props.product?.branch_name }}</span>
      </locale-link>
      <h2 class="text-2xl">{{ props.product?.product_name }}</h2>
      <div v-if="isDistanceShown" class="distance mt-2">
        <div>{{ $t('distance_from_you', { distance_from_you: props.product.distance }) }}</div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { UiProductInfo } from '@/types/product'

const props = defineProps<{
  product: UiProductInfo
}>()

const { regionId } = useRegion()

const isDistanceShown = computed(() => {
  if (!props.product?.distance) return false
  return parseFloat(props.product.distance || '') <= 10
})
</script>

<style lang="scss" scoped></style>
